import { render, staticRenderFns } from "./ImageAnnouncementCarousel.vue?vue&type=template&id=78c049fd&scoped=true&"
import script from "./ImageAnnouncementCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageAnnouncementCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ImageAnnouncementCarousel.vue?vue&type=style&index=0&id=78c049fd&lang=scss&scoped=true&"
import style1 from "./ImageAnnouncementCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c049fd",
  null
  
)

export default component.exports